'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _actions = require('../actions');

var _LinkForm = require('../components/LinkForm');

var _LinkForm2 = _interopRequireDefault(_LinkForm);

var _propTypes3 = require('../propTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return { pages: state.pages };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onPageChanged: function onPageChanged(newPage) {
      dispatch((0, _actions.changeEditingNavigationItem)({ page_id: newPage ? newPage.id : null }));
    },

    onTitleChanged: function onTitleChanged(newTitle) {
      dispatch((0, _actions.changeEditingNavigationItem)({ title: newTitle }));
    }
  };
};

var LinkEditor = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_LinkForm2.default);

LinkEditor.propTypes = {
  navigationItem: _propTypes3.NavigationItemPropType.isRequired,
  onSubmit: _propTypes2.default.func.isRequired
};

exports.default = LinkEditor;


//////////////////
// WEBPACK FOOTER
// ./~/cadmus-navbar-admin/lib/containers/LinkEditor.js
// module id = 416
// module chunks = 0